export default {
  computed: {
    hostURL() {
      return window.socialAppConfig.hostURL;
    },
    vapidPublicKey() {
      return window.socialAppConfig.vapidPublicKey;
    },
    enabledLanguages() {
      return window.socialAppConfig.enabledLanguages;
    },
    isEnterprise() {
      return window.socialAppConfig.isEnterprise === 'true';
    },
  },
};
